import styled from 'styled-components';

export const StyledSubTitle = styled.h2`
  /*  */
`;
